import _classCallCheck from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _defineProperty from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  padding-right: 0;\n  width: 100%;\n\n  &::after {\n    background-color: ", ";\n    bottom: 6px;\n    content: '';\n    height: 2px;\n    left: ", "px;\n    position: absolute;\n    right: ", "px;\n    transform: scaleX(", ");\n    transition: transform ", ";\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  width: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  flex-grow: 1;\n  max-width: 100%;\n  min-width: 0;\n  position: relative;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { __rest } from "tslib";
import React, { cloneElement, PureComponent, Children } from 'react';
import styled from 'styled-components';
import Select, { components } from 'react-select';
import { FixedSizeList } from 'react-window';
import { Placeholder } from '@scp/ui-shared/components/typography';
import { color, property, zIndex } from '@scp/ui-shared/theme/variables';
import { FIELD_INNER_PADDING } from '@scp/ui-shared/components/form-fields/constants';
import { TriggerButton, ClearButton, FieldBase } from '@scp/ui-shared/components/form-fields/base';
import { hasKey } from '@scp/ui-shared/core/types';
import { Loader } from '@scp/ui-shared/components';
import { getE2eLabel } from '@scp/ui-shared/components/utils'; // eslint-disable-next-line import/no-relative-parent-imports

import { FieldWrapper } from '../FieldWrapper'; // eslint-disable-next-line import/no-relative-parent-imports

import { Label } from '../Label';
import { FieldInput } from './FieldInput';
import { Value } from './Value';
import { DropdownMenu } from './DropdownMenu';
import { Option } from './Option';
import { GroupHeading } from './GroupHeading';
import { flattenOptions, getValues } from './utils'; // eslint-disable-next-line import/no-relative-parent-imports

import { FieldDescription } from '../FieldDescription';
import { baselineToPx } from '@scp/ui-shared/theme/utils';
var E2E_LABEL_SUFFIX = 'field';
var E2E_INPUT_SUFFIX = '-field-input';
var E2E_VALUE_SUFFIX = '-field-value';
var PORTAL_TARGET = document.getElementById('dropdown-root');
var TEXT = {
  DROPDOWN_INDICATOR: 'Open Select'
};
var STYLE_OVERRIDES = {
  menuPortal: function menuPortal(styles) {
    return Object.assign(Object.assign({}, styles), {
      zIndex: zIndex.dropdown
    });
  },
  menuList: function menuList(styles) {
    return Object.assign(Object.assign({}, styles), {
      padding: '0.28em 0'
    });
  },
  group: function group(styles) {
    return Object.assign(Object.assign({}, styles), {
      padding: 0
    });
  },
  container: function container(styles) {
    return Object.assign(Object.assign({}, styles), _defineProperty({}, 'pointerEvents', 'auto'));
  }
};
var ValuesWrapper = styled.div(_templateObject());
var LabelContentWrapper = styled.div(_templateObject2());
var LoaderWrapper = styled.div(_templateObject3(), baselineToPx(10));

var EmptyComponent = function EmptyComponent() {
  return null;
};

var CustomLoader = function CustomLoader() {
  return React.createElement(LoaderWrapper, null, React.createElement(Loader, {
    size: 20
  }));
};

export var SelectField = /*#__PURE__*/function (_PureComponent) {
  _inherits(SelectField, _PureComponent);

  var _super = _createSuper(SelectField);

  function SelectField() {
    var _this;

    _classCallCheck(this, SelectField);

    _this = _super.apply(this, arguments);
    _this.state = {
      menuIsOpen: false,
      searchValue: ''
    };

    _this.closeMenuIfOpen = function () {
      if (!_this.state.menuIsOpen) {
        return;
      }

      _this.closeMenu();
    };

    _this.openMenu = function () {
      _this.setState({
        menuIsOpen: true
      });

      !!_this.props.onMenuOpen && _this.props.onMenuOpen();
    };

    _this.closeMenu = function () {
      _this.setState({
        menuIsOpen: false
      });

      _this.props.onMenuClose && _this.props.onMenuClose();
    };

    _this.handleScroll = function (e) {
      // `react-select` doesn't close element when scrolling other content (except document.body).
      if (!PORTAL_TARGET || e.target instanceof HTMLInputElement) {
        return false;
      }

      if (!hasKey(e, 'target') || !(e.target instanceof Element)) {
        return true;
      }

      return !PORTAL_TARGET.contains(e.target);
    };

    _this.handleChange = function (selectedValues, options) {
      var _this$props = _this.props,
          onClear = _this$props.onClear,
          onChange = _this$props.onChange,
          maxSelectedItems = _this$props.maxSelectedItems,
          value = _this$props.value,
          isMulti = _this$props.isMulti;

      if (isMulti) {
        var isSelectOptionAction = options.action === 'select-option';
        var option = options.option && options.option.value;
        var isOptionSelected = value.find(function (f) {
          return f.value === option;
        });
        var isDisabled = !!selectedValues && !!maxSelectedItems && maxSelectedItems < selectedValues.length;
        if (isSelectOptionAction && isDisabled && !isOptionSelected) return;
      }

      if (!!onClear && options.action === 'clear') {
        onClear(selectedValues, options);
        return;
      }

      !!onChange && onChange(selectedValues, options);
    };

    _this.handleInputChange = function (searchValue, _ref) {
      var action = _ref.action;
      if (action === 'set-value') return;

      _this.setState({
        searchValue: searchValue
      });
    };

    _this.renderControl = function (_a) {
      var cx = _a.cx,
          innerProps = _a.innerProps,
          innerRef = _a.innerRef,
          theme = _a.theme,
          props = __rest(_a, ["cx", "innerProps", "innerRef", "theme"]);

      return React.createElement(SelectUI, Object.assign({}, props, innerProps, {
        disabled: props.isDisabled,
        ref: innerRef,
        isInvalid: !!_this.props.errorText,
        isFocused: false,
        fieldFocused: props.isFocused
      }));
    };

    _this.renderValues = function (_ref2) {
      var children = _ref2.children,
          hasValue = _ref2.hasValue,
          selectProps = _ref2.selectProps;
      var selectedValueRenderer = _this.props.selectedValueRenderer;
      var isMulti = selectProps.isMulti,
          value = selectProps.value,
          placeholder = selectProps.placeholder,
          options = selectProps.options,
          isSearchable = selectProps.isSearchable,
          menuIsOpen = selectProps.menuIsOpen;
      /*
       * Rendered input is a second node of the default children
       * https://github.com/JedWatson/react-select/blob/master/src/Select.js#L1776
       *
       * First one is a value (or an array of values)
       */
      // @ts-ignore

      var renderedInput = children[1]; // Provide additional props to a rendered input component (see renderInput())

      var inputElement = isSearchable ? cloneElement(renderedInput, {
        menuIsOpen: menuIsOpen
      }) : cloneElement(renderedInput, {
        'data-e2e': getE2eLabel(_this.props.id, E2E_INPUT_SUFFIX)
      });
      var flattenedOptionsCount = flattenOptions(options).length;
      var renderedValue = null;

      if (hasValue) {
        renderedValue = !!selectedValueRenderer ? selectedValueRenderer(getValues(value, isMulti)) : React.createElement(Value, {
          values: getValues(value, isMulti),
          totalCount: flattenedOptionsCount
        });
      }

      return React.createElement(ValuesWrapper, {
        "data-e2e": getE2eLabel(_this.props.id, E2E_VALUE_SUFFIX)
      }, hasValue ? renderedValue : React.createElement(Placeholder, null, placeholder), inputElement);
    };

    _this.renderInput = function (_a) {
      var cx = _a.cx,
          inputProps = __rest(_a, ["cx"]);

      return React.createElement(FieldInput, Object.assign({
        "aria-describedby": _this.props.ariaDescribedBy
      }, inputProps, {
        name: _this.props.name,
        searchPlaceholder: _this.props.searchPlaceholder,
        "data-e2e": getE2eLabel(_this.props.id, E2E_INPUT_SUFFIX)
      }));
    };

    _this.renderMenu = function (_ref3) {
      var selectProps = _ref3.selectProps,
          innerRef = _ref3.innerRef,
          innerProps = _ref3.innerProps,
          children = _ref3.children,
          placement = _ref3.placement;
      var _this$props2 = _this.props,
          additionalMenuHeaderRenderer = _this$props2.additionalMenuHeaderRenderer,
          showSelectAll = _this$props2.showSelectAll,
          selectedCountTitle = _this$props2.selectedCountTitle,
          dropdownMenuHeight = _this$props2.dropdownMenuHeight,
          dropdownHasMinWidth = _this$props2.dropdownHasMinWidth;
      return React.createElement(DropdownMenu, {
        onChange: selectProps.onChange,
        options: selectProps.options,
        selectedOptions: getValues(selectProps.value, selectProps.isMulti),
        showSelectAll: selectProps.isMulti && showSelectAll,
        onContentMouseDown: innerProps.onMouseDown,
        onContentMouseMove: innerProps.onMouseMove,
        searchValue: selectProps.inputValue,
        onFilterOption: selectProps.filterOption,
        additionalMenuHeaderRenderer: additionalMenuHeaderRenderer,
        selectedCountTitle: selectedCountTitle,
        dropdownMenuHeight: dropdownMenuHeight,
        dropdownHasMinWidth: dropdownHasMinWidth,
        innerRef: innerRef,
        placement: placement
      }, children);
    };

    _this.renderMenuList = function (props) {
      if (_this.props.virtualized) {
        var itemHeight = 32;
        var children = props.children,
            maxHeight = props.maxHeight;
        var childrenArray = Children.toArray(children);
        var itemsHeight = childrenArray.length * itemHeight;
        var listHeight = Math.min(itemsHeight, maxHeight); // There is bug with react-select and react-virtualized. List cannot be scrolled with mouse.
        // https://github.com/bvaughn/react-virtualized/issues/1596
        // So react-window was introduced here.
        // Consider to switch back to react-virtualized after it is resolved, because these libs are very similar.

        return React.createElement(FixedSizeList, {
          height: listHeight,
          itemCount: childrenArray.length,
          itemSize: itemHeight,
          width: "100%"
        }, function (_ref4) {
          var index = _ref4.index,
              style = _ref4.style;
          return React.createElement("div", {
            style: style
          }, childrenArray[index]);
        });
      }

      return React.createElement(components.MenuList, Object.assign({}, props));
    };

    _this.renderOption = function (option) {
      var _this$props3 = _this.props,
          customLabelRenderer = _this$props3.optionLabelRenderer,
          optionComponent = _this$props3.optionComponent,
          maxSelectedItems = _this$props3.maxSelectedItems,
          value = _this$props3.value;
      var isDisabled = !!maxSelectedItems && maxSelectedItems <= value.length && !option.isSelected;
      var OptionComponent = optionComponent ? optionComponent : Option;

      var optionLabelRenderer = customLabelRenderer && function () {
        return customLabelRenderer(option);
      };

      var isMulti = option.isMulti,
          innerRef = option.innerRef,
          optionProps = __rest(option, ["isMulti", "innerRef"]);

      return React.createElement(OptionComponent, Object.assign({
        innerRef: innerRef,
        isMulti: !!isMulti,
        disabled: isDisabled,
        indicator: option.data.count,
        optionLabelRenderer: optionLabelRenderer
      }, optionProps, option.innerProps), option.children);
    };

    _this.renderClearIndicator = function (_ref5) {
      var clearValue = _ref5.clearValue,
          innerProps = _ref5.innerProps;
      return React.createElement(ClearButton, Object.assign({
        onClick: clearValue,
        inputId: _this.props.id,
        label: _this.props.label
      }, innerProps));
    };

    _this.renderDropdownIndicator = function (_ref6) {
      var selectProps = _ref6.selectProps,
          innerProps = _ref6.innerProps;
      if (selectProps.isLoading) return null;
      return React.createElement(TriggerButton, Object.assign({}, innerProps, {
        "aria-hidden": true,
        tabIndex: -1,
        title: TEXT.DROPDOWN_INDICATOR,
        disabled: selectProps.isDisabled
      }));
    };

    return _this;
  }

  _createClass(SelectField, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', this.closeMenuIfOpen);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.closeMenuIfOpen);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _a = this.props,
          id = _a.id,
          label = _a.label,
          errorText = _a.errorText,
          isDisabled = _a.isDisabled,
          components = _a.components,
          hiddenLabel = _a.hiddenLabel,
          onChange = _a.onChange,
          showSelectAll = _a.showSelectAll,
          hideError = _a.hideError,
          loadOptions = _a.loadOptions,
          isMulti = _a.isMulti,
          optionLabelRenderer = _a.optionLabelRenderer,
          selectedValueRenderer = _a.selectedValueRenderer,
          implementation = _a.implementation,
          description = _a.description,
          isLoading = _a.isLoading,
          props = __rest(_a, ["id", "label", "errorText", "isDisabled", "components", "hiddenLabel", "onChange", "showSelectAll", "hideError", "loadOptions", "isMulti", "optionLabelRenderer", "selectedValueRenderer", "implementation", "description", "isLoading"]);

      var selectProps = Object.assign(Object.assign({
        menuPosition: 'fixed',
        menuPortalTarget: PORTAL_TARGET,
        isDisabled: isDisabled || isLoading,
        isLoading: isLoading,
        isMulti: isMulti,
        openMenuOnFocus: false,
        escapeClearsValue: true,
        tabSelectsValue: false,
        hideSelectedOptions: false,
        tabIndex: isDisabled ? '-1' : '0',
        menuIsOpen: this.state.menuIsOpen,
        loadingMessage: function loadingMessage() {
          return null;
        },
        noOptionsMessage: function noOptionsMessage() {
          return null;
        }
      }, props), {
        onChange: onChange ? this.handleChange : undefined,
        onMenuOpen: this.openMenu,
        onMenuClose: this.closeMenuIfOpen,
        closeMenuOnScroll: this.handleScroll,
        inputValue: this.state.searchValue,
        onInputChange: this.handleInputChange,
        inputId: id,
        components: Object.assign({
          ValueContainer: this.renderValues,
          Control: this.renderControl,
          Input: this.renderInput,
          Menu: this.renderMenu,
          ClearIndicator: this.renderClearIndicator,
          DropdownIndicator: this.renderDropdownIndicator,
          Option: this.renderOption,
          MenuList: this.renderMenuList,
          IndicatorSeparator: EmptyComponent,
          GroupHeading: GroupHeading,
          LoadingIndicator: CustomLoader
        }, components),
        styles: STYLE_OVERRIDES,
        closeMenuOnSelect: !isMulti,
        backspaceRemovesValue: !props.isSearchable
      });
      return React.createElement(FieldWrapper, {
        id: id,
        errorText: errorText,
        hideError: hideError
      }, React.createElement(LabelContentWrapper, null, React.createElement(Label, {
        htmlFor: id,
        disabled: isDisabled,
        visuallyHidden: hiddenLabel,
        dataE2e: "".concat(this.props.id, "-").concat(E2E_LABEL_SUFFIX),
        onClick: function onClick() {
          return _this2.openMenu();
        }
      }, label), this.props.afterLabelComponent), !!description && React.createElement(FieldDescription, {
        id: id,
        description: description
      }), implementation(selectProps));
    }
  }]);

  return SelectField;
}(PureComponent);
SelectField.defaultProps = {
  errorText: '',
  hiddenLabel: false,
  showSelectAll: false,
  isClearable: true,
  implementation: function implementation(props) {
    return React.createElement(Select, Object.assign({}, props));
  },
  virtualized: false
};
export var SelectUI = styled(FieldBase)(_templateObject4(), color.action, FIELD_INNER_PADDING, FIELD_INNER_PADDING, function (props) {
  return props.fieldFocused ? 1 : 0;
}, property.transition);